import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios, { AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";
import { StaffContent } from "../DTOs/responses/staff";

type StaffResponse = AxiosResponse<StaffContent>;

export const useStaff = (): UseQueryResult<StaffContent> => {
  const { i18n } = useTranslation();
  const language = i18n.language;

  const fetchStaff = (): Promise<StaffResponse> => {
    const headers = {
      Accept: "*/*",
      "Accept-Language": language,
    };

    return axios.get(`${process.env.REACT_APP_BASE_URL}/staff`, {
      headers,
    });
  };

  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["staff-get", language],
    queryFn: fetchStaff,
    select: (data) => data.data,
  });
};
